import { resolveBannerStyle } from "../helpers";

/**
 * Copied from the `custom` variant of components/button/ButtonPlugins.js, plus the h-8
 * the page passes at its call site, so the CTA matches the "Cek Live Tracking" button
 * exactly in shape and size. It stays an anchor rather than becoming a ButtonPlugins:
 * this is a real destination, and buyers should keep middle-click, open-in-new-tab and
 * copy-link — which a <button> with an onClick would take away.
 *
 * Colours are NOT copied: those come from the banner's own preset.
 */
const CTA_BUTTON_CLASSNAME =
  "inline-flex items-center h-8 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none";

/**
 * Admin-authored notices the merchant has switched on for their tracking page — fraud
 * warnings, support instructions and the like.
 *
 * Title and body are plain text from the admin panel and are rendered as text, never as
 * markup. Banners stack in the order the API returns them (oldest first).
 */
export default function TrackingBanners({ banners }) {
  if (!banners?.length) return null;

  return (
    <div className="space-y-3">
      {banners.map((banner) => {
        const { classNames, containerStyle, textStyle, buttonStyle } =
          resolveBannerStyle(banner.style);

        return (
          <div
            key={banner.id}
            className={`rounded-lg p-4 ${classNames.container}`}
            style={containerStyle}
          >
            <div className={`font-bold ${classNames.text}`} style={textStyle}>
              {banner.title}
            </div>
            {/* whitespace-pre-line keeps the line breaks an admin typed into the body. */}
            <div
              className={`mt-1 text-sm whitespace-pre-line ${classNames.text}`}
              style={textStyle}
            >
              {banner.body}
            </div>
            {!!banner.cta && (
              <a
                href={banner.cta.url}
                target="_blank"
                // The destination is admin-controlled, but it is still a cross-origin link
                // opened from a public page — deny it access to window.opener.
                rel="noopener noreferrer"
                className={`mt-3 ${CTA_BUTTON_CLASSNAME} ${classNames.button}`}
                style={buttonStyle}
              >
                {banner.cta.text}
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
}
